
<template>
  <div>
    <v-skeleton-loader
      v-if="loading"
      class="m-auto"
      type="table"
      transition="scale-transition"
    />
    <div
      v-if="standard"
      :key="standard.id"
    >
      <div
        class="standard-block"
      >
        <div>
          <strong>{{ standard.analysisType.name[userLang] }}</strong>
        </div>
        <!-- we have 4 diffrent allowed combination for norm levels
              1: just 3 levels (veryLow, low, min OR max, high, veryhigh)
              2: min and max
              3: all 6 levels -->
        <MinAndMaxLevel
          v-if="isMinAndMaxLevel"
          :norms="availableNorms"
          :measureUnit="translatedMeasureUnit"
        />
        <AllLevels
          v-else
          :norms="availableNorms"
          :measureUnit="translatedMeasureUnit"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { has } from 'lodash';
import AllLevels from './AllLevels.vue';
import MinAndMaxLevel from './MinAndMaxLevel.vue';

export default {
    components: {
        AllLevels,
        MinAndMaxLevel,
    },
    props: {
        standard: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            availableNorms: [],
            measureUnit: '',
            loading: false,
        };
    },
    computed: {
        ...mapGetters([
            'userLang',
            'teamMainLang',
        ]),
        normHasAllLevels() {
            return Object.keys(this.availableNorms).length === 6;
        },
        isMinAndMaxLevel() {
            return (Object.keys(this.availableNorms).length === 2 && has(this.availableNorms, 'minimum') && has(this.availableNorms, 'maximum'));
        },
        translatedMeasureUnit() {
            return this.measureUnit[this.userLang] || this.measureUnit[this.teamMainLang] || '';
        },
    },
    created() {
        this.loading = true;
        const { norm: { id, ...res }, analysisType: { measureUnit } } = this.standard;
        this.availableNorms = res;
        this.measureUnit = measureUnit;
        this.loading = false;
    },
};

</script>

<style lang="scss" scoped>
.caption-title {
  display: inline-block;
  font-weight: bold;
  font-size: 16px;
  margin-top: 16px;
  margin-bottom: 16px;

  &::after {
    content: '';
    display: block;
    width: 30px;
    height: 2px;
    background-color: #DC582A;
  }
}

.standard-family-title {
  color: #aaa;
  text-transform: uppercase;
  margin-bottom: 6px;
}

.standard-block {
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);
  padding: 4px 7px;
  margin-bottom: 8px;
  &:last-of-type {
    border-bottom: 0;
  }
}

</style>
